import type { IStudentListPreviewRequest } from "@/providers/store/api/reports/reports.interface";

import {
  SelectedDataType,
  type SelectedData,
} from "../map-panel-context";

import { buildBoundaryStudentListSelectionShapes } from "./components/boundary-student-list-report.utils";

import type { ShapeItem } from "./components/shape-item.types";

export interface StudentListReportActionModel {
  getPreviewRequest: () => IStudentListPreviewRequest | null;
  selectionShapes: ShapeItem[];
}

export function resolveStudentListReportActionModel(
  selectedData: SelectedData,
): StudentListReportActionModel | null {
  if (!selectedData?.payload) {
    return null;
  }

  if (selectedData.type === SelectedDataType.SELECTION) {
    const { payload } = selectedData;
    if (payload.useSchoolCountsOnly !== false || !payload.getStudentListPreviewRequest) {
      return null;
    }

    return {
      getPreviewRequest: payload.getStudentListPreviewRequest,
      selectionShapes: payload.shapes,
    };
  }

  if (selectedData.type === SelectedDataType.STUDENT_CLUSTER) {
    return {
      getPreviewRequest: selectedData.payload.getStudentListPreviewRequest,
      selectionShapes: [],
    };
  }

  if (selectedData.type === SelectedDataType.BOUNDARY) {
    const { payload } = selectedData;
    const { plotting } = payload;
    if (!plotting || plotting.useSchoolCountsOnly) {
      return null;
    }

    return {
      getPreviewRequest: plotting.getStudentListPreviewRequest,
      selectionShapes: buildBoundaryStudentListSelectionShapes(payload),
    };
  }

  return null;
}
